import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

const useCredentials = ({ createTenantData, setCreateTenantData }) => {
  const [isValueError, setIsValueError] = useState(false)
  const [isDescriptionError, setIsDescriptionError] = useState(false)
  const [validation, setValidation] = useState({})
  const [allValidation, setAllValidation] = useState(false)
  const { allCredentialsKey } = useSelector((state) => state.tenants)
  const fieldNames = allCredentialsKey?.map((feild) => feild.name)

  let flag = false

  Object.keys(validation).forEach((key) => {
    if (validation[key] === true) {
      flag = true
    }
    return flag
  })

  useEffect(() => {
    if (flag === false) {
      setAllValidation(false)
    }
  }, [flag, setAllValidation])

  useEffect(() => {
    if ((!createTenantData?.value || !createTenantData?.description) && allCredentialsKey && Object.keys(allCredentialsKey)?.length > 0) {
      const keys = allCredentialsKey.map((key) => key.name)
      const data = Object.fromEntries(keys.map(k => [k, '']))
      setCreateTenantData({
        ...createTenantData,
        value: { ...data },
        description: { ...data }
      })
    }
  }, [allCredentialsKey, createTenantData])

  return {
    isValueError,
    setIsValueError,
    isDescriptionError,
    setIsDescriptionError,
    fieldNames,
    validation,
    setAllValidation,
    setValidation,
    allValidation
  }
}

export default useCredentials
